import { X } from 'lucide-react';

interface SelectedItemBubblesProps {
  selectedIds: number[];
  onRemoveItem: (id: number) => void;
  getItemName: (id: number) => string;
}

export default function SelectedItemBubbles({
  selectedIds,
  onRemoveItem,
  getItemName,
}: SelectedItemBubblesProps) {
  if (selectedIds.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {selectedIds.map(id => (
        <div
          key={id}
          className="flex items-center gap-1 rounded-md border px-2 py-1 text-xs"
          style={{
            backgroundColor: 'var(--anl-accent)',
            color: '#ffffff',
            borderColor: 'var(--anl-accent)',
          }}
        >
          <span className="max-w-[120px] truncate">{getItemName(id)}</span>
          <button
            onClick={() => onRemoveItem(id)}
            className="rounded p-0.5 transition-colors"
            style={{ color: '#ffffff' }}
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  );
}
